import React from "react";
import { FormPageTemplate } from "../../components/templates";
const FormPage = () => {
  return <FormPageTemplate />;
};
export { FormPage };
